import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_COFFEE_GEO_PROFILE_QUALITY = createFcmDetails('coffee_geo_profile_quality', {
	owner: 'supporters pack',
	context: 'petition page',
	description: 'Indicates that localization fields (e.g. country, city, ...) should be present in the sign form.',
	import: false,
});
